import { useEffect, useState, useRef } from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext/AuthContext';
import { AuthActionType } from '../context/AuthContext/AuthReducer';
import Header from './components/Header/Header';
import NotFound from '../pages/NotFound/NotFound';
import Home from './pages/Home/Home';
import style from './shop.module.scss';
import cx from 'classnames';
import Cart from './pages/Cart/Cart';
import Checkout from './pages/Checkout/Checkout';
import SingleProduct from './pages/SingleProduct/SingleProduct';
import MiniCart from './components/Cart/MiniCart';

import ThankYou from './pages/ThankYou/ThankYou';
import DateModal from './components/DateModal/DateModal';
import { useCartContext } from '../context/CartContext/CartContext';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import AcceptOffer from './pages/AcceptOffer/AcceptOffer';

function Shop() {
  const { user, dispatch } = useAuthContext();
  const { cart } = useCartContext();
  const [collapsedSidebar, setCollapsedSidebar] = useState<boolean>(false);
  const [minicartOpened, setMinicartOpened] = useState<boolean>(false);
  const [noSideBar, setNoSideBar] = useState<boolean>(false);
  const [dateModalOpen, setDateModalOpen] = useState<boolean>(false);

  // Use a ref to track if the initial date check has been performed.
  const initialDateCheckDone = useRef(false);

  // --- REFACTORED useEffect LOGIC ---
  useEffect(() => {
    // Only run the logic if the cart object exists and the initial check hasn't been done.
    if (cart && !initialDateCheckDone.current) {
      // Condition to open the modal:
      // 1. The cart has products in it.
      // 2. The cart does NOT have start/end dates set.
      if (cart.products.length > 0 && !cart.hasStartEndDates()) {
        setDateModalOpen(true);
      }
      // Mark the initial check as complete so this doesn't run again on every cart update.
      initialDateCheckDone.current = true;
    }
  }, [cart]); // Dependency on `cart` is correct.

  return (
    <main
      className={cx(
        'cs-shop-layout-wrapper',
        collapsedSidebar ? 'collapsed' : null,
        noSideBar ? 'no-sidebar' : null
      )}
    >
      <div className="cs-header">
        <Header
          minicartOpened={minicartOpened}
          setMinicartOpened={setMinicartOpened}
          dateModalOpen={dateModalOpen}
          setDateModalOpen={setDateModalOpen}
        ></Header>
      </div>

      <div className="cs-content-wrapper">
        <Routes>
          <Route
            index
            element={
              <Home
                collapsedSidebar={collapsedSidebar}
                setCollapsedSidebar={setCollapsedSidebar}
              />
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <PrivacyPolicy
                collapsedSidebar={true}
                setCollapsedSidebar={setCollapsedSidebar}
              />
            }
          />
          <Route
            path="/thank-you"
            element={<ThankYou setNoSideBar={setNoSideBar} />}
          />
          <Route
            path="/accept-offer/:token"
            element={<AcceptOffer setNoSideBar={setNoSideBar} />}
          />
          <Route
            path="/cart"
            element={
              <Cart
                collapsedSidebar={collapsedSidebar}
                setCollapsedSidebar={setCollapsedSidebar}
              />
            }
          />
          <Route
            path="/checkout"
            element={
              <Checkout
                collapsedSidebar={collapsedSidebar}
                setCollapsedSidebar={setCollapsedSidebar}
              />
            }
          />
          <Route
            path="/product/:id"
            element={
              <SingleProduct
                collapsedSidebar={collapsedSidebar}
                setCollapsedSidebar={setCollapsedSidebar}
              />
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <DateModal
        open={dateModalOpen}
        setOpen={setDateModalOpen}
        onAction={() => {}}
      ></DateModal>
      <MiniCart
        opened={minicartOpened}
        setOpened={setMinicartOpened}
      ></MiniCart>
    </main>
  );
}

export default Shop;
